module.exports = __webpack_public_path__ + "img/source05_9.5ec52b92.png";